import PropTypes from 'prop-types';

export const propTypes = {
  advertising: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    imageFilename: PropTypes.string,
    imageContentType: PropTypes.string,
    imageUrl: PropTypes.string,
    link: PropTypes.string,
    startDate: PropTypes.string,
    finishDate: PropTypes.string,
  }),
};

export const defaultProps = {
  advertising: {
    id: null,
    name: '',
    imageFilename: null,
    imageContentType: null,
    imageUrl: null,
    link: '',
    startDate: '',
    finishDate: '',
  },
};
